import React from 'react';
import { motion } from 'framer-motion';
import resortNight from '../assets/resort_night.webp';

const HomeServices = () => {
  return (
    <section className="relative h-[320px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={resortNight}
          alt="Our Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="space-y-4"
        >
          <span className="text-orange-500 font-black uppercase tracking-[0.4em] text-[10px] block">
            WHAT WE DO
          </span>
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-white leading-tight">
            Our <span className="text-orange-500 italic">Services</span>
          </h2>
          <p className="text-white/90 text-lg md:text-xl font-medium max-w-2xl">
            We handle all your travel needs with care and expertise.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeServices;
